import React, { Fragment, useEffect, useRef, useState } from 'react';

import { Button } from '@material-ui/core';

import ConfirmDialog from '../../../common/dialogs/ConfirmDialog';
import { useRevertAgreement, useUpdateAgreement } from '../Agreement.hooks';
import { Agreement } from '../Agreement.interface';
import { PublishStatus } from '../../../common/PublishStatusLabels';

export interface AgreementStatusActionsProps {
  agreement: Agreement;
  onChange?: (agreement: Agreement) => void;
}

const AgreementStatusActions: React.FC<AgreementStatusActionsProps> = ({
  agreement,
  onChange
}) => {
  const [openRevertDialog, setOpenRevertDialog] = useState(false);
  const [openPublishDialog, setOpenPublishDialog] = useState(false);
  const { agreement: updatedAgreement, patch } = useUpdateAgreement(
    agreement.id
  );
  const { agreement: revertedAgreement, revert } = useRevertAgreement(
    agreement.id
  );
  const onChangeRef = useRef(onChange);
  useEffect(() => {
    if (updatedAgreement && onChangeRef && onChangeRef.current) {
      onChangeRef.current(updatedAgreement);
    }
  }, [updatedAgreement]);
  useEffect(() => {
    if (revertedAgreement && onChangeRef && onChangeRef.current) {
      onChangeRef.current(revertedAgreement);
    }
  }, [revertedAgreement]);
  switch (agreement.status) {
    case 'draft':
      return (
        <Fragment>
          {agreement.version > 1 && (
            <Fragment>
              <Button
                variant='outlined'
                color='secondary'
                onClick={() => setOpenRevertDialog(true)}
              >
                Revert to Previous Version
              </Button>
              {openRevertDialog && (
                <ConfirmDialog
                  title={`Revert to version: ${agreement.version - 1}`}
                  message={`Are you sure you want to erase any changes in ${
                    agreement.name
                  } version: ${agreement.version} and rollback to version: ${
                    agreement.version - 1
                  }? You will not be able to undo this change.`}
                  open={openRevertDialog}
                  onCancel={() => {
                    setOpenRevertDialog(false);
                  }}
                  onConfirm={() => {
                    setOpenRevertDialog(false);
                    revert();
                  }}
                />
              )}
            </Fragment>
          )}
          <Button
            variant='contained'
            color='secondary'
            onClick={() => setOpenPublishDialog(true)}
          >
            Publish
          </Button>
          {openPublishDialog && (
            <ConfirmDialog
              open={openPublishDialog}
              title={`Publish version: ${agreement.version}`}
              message={`Are you sure you want to publish ${agreement.name} version: ${agreement.version}? Your changes will be permanent.`}
              onCancel={() => {
                setOpenPublishDialog(false);
              }}
              onConfirm={() => {
                setOpenPublishDialog(false);
                patch({ status: PublishStatus.Published });
              }}
            />
          )}
        </Fragment>
      );
    case 'published':
      return (
        <Fragment>
          <Button
            variant='contained'
            color='secondary'
            onClick={() => patch({ status: PublishStatus.Draft })}
          >
            Start New Version
          </Button>
        </Fragment>
      );
    default:
      return null;
  }
};

export default AgreementStatusActions;
